import { j as O } from "./jsx-runtime-p91LotPX.mjs";
import H, { useMemo as L, useRef as F, useEffect as k, useContext as be, useState as ve } from "react";
import { f as I, g as me, h as he, i as V, e as xe, j as Ie, k as ye, l as Re, C as P, m as Ce, c as Se, n as we, o as De, s as Ae } from "./core.esm-D9FG3ApV.mjs";
import { p as Te } from "./styled-components.browser.esm-DBaC0ZEI.mjs";
function W(e, t, r) {
  const n = e.slice();
  return n.splice(r < 0 ? n.length + r : r, 0, n.splice(t, 1)[0]), n;
}
function Ne(e, t) {
  return e.reduce((r, n, o) => {
    const a = t.get(n);
    return a && (r[o] = a), r;
  }, Array(e.length));
}
function E(e) {
  return e !== null && e >= 0;
}
function Oe(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function Ee(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const J = (e) => {
  let {
    rects: t,
    activeIndex: r,
    overIndex: n,
    index: o
  } = e;
  const a = W(t, n, r), s = t[o], i = a[o];
  return !i || !s ? null : {
    x: i.left - s.left,
    y: i.top - s.top,
    scaleX: i.width / s.width,
    scaleY: i.height / s.height
  };
}, j = {
  scaleX: 1,
  scaleY: 1
}, He = (e) => {
  var t;
  let {
    activeIndex: r,
    activeNodeRect: n,
    index: o,
    rects: a,
    overIndex: s
  } = e;
  const i = (t = a[r]) != null ? t : n;
  if (!i)
    return null;
  if (o === r) {
    const l = a[s];
    return l ? {
      x: 0,
      y: r < s ? l.top + l.height - (i.top + i.height) : l.top - i.top,
      ...j
    } : null;
  }
  const d = je(a, o, r);
  return o > r && o <= s ? {
    x: 0,
    y: -i.height - d,
    ...j
  } : o < r && o >= s ? {
    x: 0,
    y: i.height + d,
    ...j
  } : {
    x: 0,
    y: 0,
    ...j
  };
};
function je(e, t, r) {
  const n = e[t], o = e[t - 1], a = e[t + 1];
  return n ? r < t ? o ? n.top - (o.top + o.height) : a ? a.top - (n.top + n.height) : 0 : a ? a.top - (n.top + n.height) : o ? n.top - (o.top + o.height) : 0 : 0;
}
const Q = "Sortable", Z = /* @__PURE__ */ H.createContext({
  activeIndex: -1,
  containerId: Q,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: J,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function Ve(e) {
  let {
    children: t,
    id: r,
    items: n,
    strategy: o = J,
    disabled: a = !1
  } = e;
  const {
    active: s,
    dragOverlay: i,
    droppableRects: d,
    over: l,
    measureDroppableContainers: c
  } = me(), u = he(Q, r), f = i.rect !== null, g = L(() => n.map((x) => typeof x == "object" && "id" in x ? x.id : x), [n]), y = s != null, R = s ? g.indexOf(s.id) : -1, v = l ? g.indexOf(l.id) : -1, C = F(g), h = !Oe(g, C.current), m = v !== -1 && R === -1 || h, b = Ee(a);
  V(() => {
    h && y && c(g);
  }, [h, g, y, c]), k(() => {
    C.current = g;
  }, [g]);
  const S = L(
    () => ({
      activeIndex: R,
      containerId: u,
      disabled: b,
      disableTransforms: m,
      items: g,
      overIndex: v,
      useDragOverlay: f,
      sortedRects: Ne(g, d),
      strategy: o
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [R, u, b.draggable, b.droppable, m, g, v, d, f, o]
  );
  return H.createElement(Z.Provider, {
    value: S
  }, t);
}
const Le = (e) => {
  let {
    id: t,
    items: r,
    activeIndex: n,
    overIndex: o
  } = e;
  return W(r, n, o).indexOf(t);
}, ke = (e) => {
  let {
    containerId: t,
    isSorting: r,
    wasDragging: n,
    index: o,
    items: a,
    newIndex: s,
    previousItems: i,
    previousContainerId: d,
    transition: l
  } = e;
  return !l || !n || i !== a && o === s ? !1 : r ? !0 : s !== o && t === d;
}, _e = {
  duration: 200,
  easing: "ease"
}, ee = "transform", $e = /* @__PURE__ */ P.Transition.toString({
  property: ee,
  duration: 0,
  easing: "linear"
}), ze = {
  roleDescription: "sortable"
};
function Fe(e) {
  let {
    disabled: t,
    index: r,
    node: n,
    rect: o
  } = e;
  const [a, s] = ve(null), i = F(r);
  return V(() => {
    if (!t && r !== i.current && n.current) {
      const d = o.current;
      if (d) {
        const l = Ce(n.current, {
          ignoreTransform: !0
        }), c = {
          x: d.left - l.left,
          y: d.top - l.top,
          scaleX: d.width / l.width,
          scaleY: d.height / l.height
        };
        (c.x || c.y) && s(c);
      }
    }
    r !== i.current && (i.current = r);
  }, [t, r, n, o]), k(() => {
    a && s(null);
  }, [a]), a;
}
function Pe(e) {
  let {
    animateLayoutChanges: t = ke,
    attributes: r,
    disabled: n,
    data: o,
    getNewIndex: a = Le,
    id: s,
    strategy: i,
    resizeObserverConfig: d,
    transition: l = _e
  } = e;
  const {
    items: c,
    containerId: u,
    activeIndex: f,
    disabled: g,
    disableTransforms: y,
    sortedRects: R,
    overIndex: v,
    useDragOverlay: C,
    strategy: h
  } = be(Z), m = Xe(n, g), b = c.indexOf(s), S = L(() => ({
    sortable: {
      containerId: u,
      index: b,
      items: c
    },
    ...o
  }), [u, o, b, c]), x = L(() => c.slice(c.indexOf(s)), [c, s]), {
    rect: N,
    node: X,
    isOver: re,
    setNodeRef: G
  } = xe({
    id: s,
    data: S,
    disabled: m.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: x,
      ...d
    }
  }), {
    active: A,
    activatorEvent: ne,
    activeNodeRect: oe,
    attributes: se,
    setNodeRef: K,
    listeners: ae,
    isDragging: $,
    over: ie,
    setActivatorNodeRef: ce,
    transform: le
  } = Ie({
    id: s,
    data: S,
    attributes: {
      ...ze,
      ...r
    },
    disabled: m.draggable
  }), de = ye(G, K), w = !!A, M = w && !y && E(f) && E(v), U = !C && $, Y = U && M ? le : null, ue = M ? Y ?? (i ?? h)({
    rects: R,
    activeNodeRect: oe,
    activeIndex: f,
    overIndex: v,
    index: b
  }) : null, T = E(f) && E(v) ? a({
    id: s,
    items: c,
    activeIndex: f,
    overIndex: v
  }) : b, D = A == null ? void 0 : A.id, p = F({
    activeId: D,
    items: c,
    newIndex: T,
    containerId: u
  }), fe = c !== p.current.items, q = t({
    active: A,
    containerId: u,
    isDragging: $,
    isSorting: w,
    id: s,
    index: b,
    items: c,
    newIndex: p.current.newIndex,
    previousItems: p.current.items,
    previousContainerId: p.current.containerId,
    transition: l,
    wasDragging: p.current.activeId != null
  }), z = Fe({
    disabled: !q,
    index: b,
    node: X,
    rect: N
  });
  return k(() => {
    w && p.current.newIndex !== T && (p.current.newIndex = T), u !== p.current.containerId && (p.current.containerId = u), c !== p.current.items && (p.current.items = c);
  }, [w, T, u, c]), k(() => {
    if (D === p.current.activeId)
      return;
    if (D && !p.current.activeId) {
      p.current.activeId = D;
      return;
    }
    const pe = setTimeout(() => {
      p.current.activeId = D;
    }, 50);
    return () => clearTimeout(pe);
  }, [D]), {
    active: A,
    activeIndex: f,
    attributes: se,
    data: S,
    rect: N,
    index: b,
    newIndex: T,
    items: c,
    isOver: re,
    isSorting: w,
    isDragging: $,
    listeners: ae,
    node: X,
    overIndex: v,
    over: ie,
    setNodeRef: de,
    setActivatorNodeRef: ce,
    setDroppableNodeRef: G,
    setDraggableNodeRef: K,
    transform: z ?? ue,
    transition: ge()
  };
  function ge() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      z || // Or to prevent items jumping to back to their "new" position when items change
      fe && p.current.newIndex === b
    )
      return $e;
    if (!(U && !Re(ne) || !l) && (w || q))
      return P.Transition.toString({
        ...l,
        property: ee
      });
  }
}
function Xe(e, t) {
  var r, n;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (r = e == null ? void 0 : e.draggable) != null ? r : t.draggable,
    droppable: (n = e == null ? void 0 : e.droppable) != null ? n : t.droppable
  };
}
function _(e) {
  if (!e)
    return !1;
  const t = e.data.current;
  return !!(t && "sortable" in t && typeof t.sortable == "object" && "containerId" in t.sortable && "items" in t.sortable && "index" in t.sortable);
}
const Ge = [I.Down, I.Right, I.Up, I.Left], We = (e, t) => {
  let {
    context: {
      active: r,
      collisionRect: n,
      droppableRects: o,
      droppableContainers: a,
      over: s,
      scrollableAncestors: i
    }
  } = t;
  if (Ge.includes(e.code)) {
    if (e.preventDefault(), !r || !n)
      return;
    const d = [];
    a.getEnabled().forEach((u) => {
      if (!u || u != null && u.disabled)
        return;
      const f = o.get(u.id);
      if (f)
        switch (e.code) {
          case I.Down:
            n.top < f.top && d.push(u);
            break;
          case I.Up:
            n.top > f.top && d.push(u);
            break;
          case I.Left:
            n.left > f.left && d.push(u);
            break;
          case I.Right:
            n.left < f.left && d.push(u);
            break;
        }
    });
    const l = Se({
      active: r,
      collisionRect: n,
      droppableRects: o,
      droppableContainers: d,
      pointerCoordinates: null
    });
    let c = we(l, "id");
    if (c === (s == null ? void 0 : s.id) && l.length > 1 && (c = l[1].id), c != null) {
      const u = a.get(r.id), f = a.get(c), g = f ? o.get(f.id) : null, y = f == null ? void 0 : f.node.current;
      if (y && g && u && f) {
        const v = De(y).some((x, N) => i[N] !== x), C = te(u, f), h = Ke(u, f), m = v || !C ? {
          x: 0,
          y: 0
        } : {
          x: h ? n.width - g.width : 0,
          y: h ? n.height - g.height : 0
        }, b = {
          x: g.left,
          y: g.top
        };
        return m.x && m.y ? b : Ae(b, m);
      }
    }
  }
};
function te(e, t) {
  return !_(e) || !_(t) ? !1 : e.data.current.sortable.containerId === t.data.current.sortable.containerId;
}
function Ke(e, t) {
  return !_(e) || !_(t) || !te(e, t) ? !1 : e.data.current.sortable.index < t.data.current.sortable.index;
}
const B = Te.div`
  width: 100%;
  cursor: pointer;
`;
function Je({
  children: e,
  id: t,
  disabled: r
}) {
  const {
    isDragging: n,
    setNodeRef: o,
    transform: a,
    transition: s,
    attributes: i,
    listeners: d
  } = Pe({
    id: t,
    disabled: r
  }), l = {
    opacity: n ? 0 : void 0,
    transform: P.Translate.toString(a),
    transition: s
  };
  return /* @__PURE__ */ O.jsx(O.Fragment, { children: r ? /* @__PURE__ */ O.jsx(B, { className: "SortableItem disabled ", children: e }) : /* @__PURE__ */ O.jsx(B, { className: `SortableItem ${n ? "drag-active" : ""}`, ref: o, style: l, ...i, ...d, children: e }) });
}
export {
  Je as S,
  W as a,
  Ve as b,
  We as s,
  Pe as u,
  He as v
};
//# sourceMappingURL=SortableItem-C--6XTJo.mjs.map
